module.exports = __webpack_public_path__ + "img/personcentre.6825c04.png";